import * as React from 'react';
import { TimeInterval } from '../../../models';
import { Button, IconButton, Box } from '@mui/material';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import { DayOfWeekEnum } from '../../../models';
import { DayOfWeekField, TimeField } from '.';
import { TextInputField } from './TextInputField';
import { useCallback, useMemo } from 'react';
import { Guid } from '../../../shared/utils';

export interface TimeIntervalFieldProp {
    id?: string,
    label?: string,
    values: TimeInterval[],
    onChange: (values: TimeInterval[]) => void,
    disabled?: boolean,
}

export const TimeIntervalField: React.FC<TimeIntervalFieldProp> = (props) => {
    const {
        id,
        label,
        values,
        onChange,
        disabled,
    } = props;

    const onAddNew = () => {
        const latestValue = values[values.length-1];
        onChange(values.concat({
            dayOfWeek: (latestValue?.dayOfWeek + 1 || 1) as DayOfWeekEnum,
            start: latestValue?.start || '00:00',
            end: latestValue?.end || '23:59',
        }));
    }

    const onChangeItem = useCallback(
        (idx: number, newVal: TimeInterval) => onChange(values.map((v, i) => idx === i ? newVal : v)),
        [onChange, values])

    const valuesWithId = useMemo(() => values.map(v => ({id: Guid.newGuid(), ...v})), [values])

    return (

        <div className="multipleInputsContainer">
            {label && <label style={{ fontSize: '0.875rem', marginBottom: '8px', display: 'block', fontWeight: 500 }}>{label}</label>}
            {
                valuesWithId.map((timeInterval, idx) => (
                    <div key={timeInterval.id} style={{display: 'flex', width: '100%', gap: 'var(--spacer-XS)', marginBottom: 'var(--spacer-XS)', flexWrap: 'wrap', alignItems: 'center'}}>
                        <Box flex="2 1 16rem" sx={{minWidth: 0}}><DayOfWeekField
                            id={id ? `${id}-${idx}-day-of-week` : undefined}
                            value={timeInterval.dayOfWeek}
                            onChange={dayOfWeek => onChangeItem(idx, { ...timeInterval, dayOfWeek })}
                        /></Box>
                        <Box display="flex" gap={1} alignItems="center" flexWrap="wrap" flex="3 1 22rem" sx={{minWidth: 0}}>
                            <Box flex="1 1 10rem" sx={{minWidth: 0}}><TimeField
                                id={id ? `${id}-${idx}-start` : undefined}
                                value={timeInterval.start}
                                onChange={start => onChangeItem(idx, { ...timeInterval, start })}
                            /></Box>
                            <Box flex="1 1 10rem" sx={{minWidth: 0}}><TimeField
                                id={id ? `${id}-${idx}-end` : undefined}
                                value={timeInterval.end}
                                onChange={end => onChangeItem(idx, { ...timeInterval, end })}
                            /></Box>
                            { !disabled &&
                                <IconButton
                                    id={id ? `${id}-${idx}-remove-button` : undefined}
                                    onClick={() => onChange(valuesWithId.filter((v) => v.id !== timeInterval.id))}
                                    size="small"
                                >
                                    <Remove/>
                                </IconButton> }
                        </Box>
                    </div>
                ))
            }
            { !disabled && (
                <div style={{width: '100%', display: 'flex', justifyContent: 'end', order: 10000}}>
                    <IconButton
                        id={id ? `${id}-add-button` : undefined}
                        onClick={onAddNew}
                        size="small"
                    >
                        <Add/>
                    </IconButton> 
                </div>
            )}
        </div>
    );
}
